<template>
  <!-- 情趣倾向 -->
  <div class="container">
    <!-- <div class="nav">
        <img src="../assets/img/08.png" class="img01" @click="back()" alt="">
        <div>人格类型</div>
    </div> -->
    <div class="type1" v-show="type == 1">
      <img src="../assets/img/06.png" class="w100" alt="">
      <img src="../assets/img/09.png" class="w100 img02" alt="">

      <div class="des">
        由 抖遇 社交App官方推出的<span>《BDSM情趣倾向专业测试》</span>，通过问答，帮助了解您在情趣方向，是否存在一定程度的BDSM角色倾向(例如S(Sadism萨德)或
        M(Masochism马索克)倾向)及具体分值占比。这有益于我们在与亲密伴侣的交往中，向对方更清晰地表达自己的真正需求，对于维系稳固健康的亲密关系发展有着积极作用。<br>
        在本测试中，请依据您个人的情趣态度，认真阅读并回答60道选择题。<br>
        结果会显示您最适合您的角色/身份倾向、香草倾向得
        分、实验者&幻想者占比值、以及各项权利游戏(身份)分值八角图等。更直观地与TA人结果进行对比，来判断对方与您的相似性、契合性、关系融洽度。<br>
        BDSM」(n.)是一个合成词，用来描述人类的性偏好行为模式，包含以下三组关系:绑缚与训练(Bondage & Discipline,即B/D);支配与臣服<br>
        (Dominance&submission，即D/s)萨德倾向与马索克倾向(Sadism&Masochism，即S/M)BDSM行为，是在符合社会基本行为准则与价值观基础下，进行的以愉悦为目的的实践游戏。其中涉及到「权力交换」(PoweExchange)-
        -参与者自愿选择，其中一方地将自己的一部分权力在一定时间、特定场景内，交予另一方。权利掌握者扮演「主导」角色，而权力交出者扮演「从属」身份，实践游戏由此展开。<br>
        所有BDSM行为必须经过全部参与者的认同，遵守RACK原则(Risk Aware Consensual Kink-共知风险的两愿实践)，在确保SSC(Safe,Sane
        and
        Consensual-安全、理智、知情同意)的前提下开展。同时，参与者中的任何一方，都有权随时终止游戏进行
      </div>
      <div class="start">
        <img src="../assets/img/12.png" class="w100 img04" @click="start()" alt="">
      </div>


    </div>
    <div class="type2" v-show="type == 2">
      <img src="../assets/img/07.png" class="w100" alt="">
      <img src="../assets/img/26.png" class="w100 img02" alt="">
      <div class="des">
        (16 Personality Types)测试，以瑞士心理学家荣格(Carl Jung)的《人格分类》理论，及美国心理学家迈尔斯(sabel Briggs
        Myers)与其母亲凯瑟琳·库克·布里格斯(KatharineCook Briggs)的性格分类法(Myers-Briggs Type Indicator,MBTI)为参考原型。<br>
        解锁人格类型有利于帮助了解自己的独特性格，更好地理解和欣赏人与人之间的不同。<br>
        本测试-共93道题，请选择与您实际做法相符的选项，而不是您认为怎样做比较好或理想中自己的样子。<br>
        人们有获取精力(外向或内向)、收集或洞察信息(实感或直觉)、对信息的决策或定论(思考或情感)以及处理我们周围世界(判断或认知)的相反方式，16型人格用字母代表如下能量来源:外向Extraversion(E)-内向Introversion(I);
        如果你偏好外向(E)，你就会通过与人交流和(或)做事来关注外部世界以便获得精力。<br>
        如果你偏好内向(1)，你就会通过对信息、观念和(或)理念的内省来关注外部世界以便获得精力。<br>
        感知偏好:感觉Sensing(S)-直觉Intuition (N);<br>
        如果你偏好感觉(S)，你就会注意和相信事实、细节及当前真相如果你偏好直觉(N)，你就会倾向于相信相互关系、各种理论和未来可能性。
        判断偏好:理性Thinking(T)-情感Feeling (F);<br>
        如果你偏好理性(T)，你就会利用逻辑和客观分析进行决策。
        如果你偏好情感(F)，你就会通过采取以人为本的价值观来决策
        以便创造和谐。<br>
        认知态度:判断Judging()-知觉Perceiving(P);
        如果你偏好判断(J)。你就会倾向于有组织和有秩序地行事并目决速地做出决定<br>
        如果你偏好知觉(P)，你就会倾向于灵活和适应地行事并且尽量不做决定<br>
        附:<br>
        十六型人格中没有对错好坏之分，没有哪个人格更好或更不好
      </div>
      <div class="start">
        <img src="../assets/img/12.png" class="w100 img04" @click="start()" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      type: 2
    }
  },
  mounted() {

  },

  methods: {
    back() {
      this.$router.go(-1)
    },
    start() {
      if (this.type == 1) {
        this.$router.push({
          name: "answer",
          params: {
            type: this.type
          },
          query: {
            uid: this.$route.query.uid || 0,
            token: this.$route.query.token || 0,
            env: this.$route.query.env || 0,
          }
        });
      }
      if (this.type == 2) {
        this.$router.push({
          name: "answerMBTI",
          params: {
            type: this.type
          },
          query: {
            uid: this.$route.query.uid || 0,
            token: this.$route.query.token || 0,
            env: this.$route.query.env || 0,
          }
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Group 2070 */
.type1 .des span,
.type2 .des span {
  color: rgba(135, 90, 242, 1);
}

.type1 .des,
.type2 .des {
  width: 345px;

  top: 288px;
  left: 15px;


  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 0.3rem;
  text-align: left;
  margin: 0px auto;
  color: rgba(102, 102, 102, 1);


}

.type1,
.type2 {
  padding-bottom: 1.1rem;
}

.start {
  width: 100%;
  position: fixed;
  bottom: 0px;
  background-color: white;
}

.nav {
  height: 0.44rem;
  display: flex;
  align-items: center;
}

.nav div {
  width: 100%;
  font-size: 22px;
  text-align: center;
  position: relative;
  line-height: 0.44rem;
  text-align: center;
}

.img01 {
  width: 0.22rem;
  position: absolute;
  left: 0.15rem;
  z-index: 3;
}

.img02 {
  width: 3.45rem;
  margin: 15px auto;
}

.img04 {
  width: 2.44rem;
  height: 0.44rem;
  margin: 0.2rem auto 0.5rem;
}
</style>